/* STEP 10 · E (owner "STEP 10 ADD-ON — LANE E: AUTOMATIC ALERTS" Card V1, 30-Oct-2026 23:44 KSA) — EN + AR of the Founder → Alerts
   tab (s10e.alerts) and its sidebar entry (s10e.alerts.nav). The rule names and descriptions come from the server in
   both languages (platform_alerts_text.RULE_TEXT); no provider or vendor name. */
export const I18N_S10E = {
  en: {
    s10e: {
      alerts: {
        nav: "Alerts",
        title: "Automatic alerts",
        intro: "The platform checks itself every 5 minutes and e-mails the recipients below (and shows the same alert in the bell) when something goes wrong. The same alert is not sent again inside its window; an alert that stays open is a line in the 08:00 KSA digest; a resolved message is sent when it clears.",
        lastCheck: "Last check",
        never: "never",
        checkNow: "Check now",
        checked: "Checked",
        sendTest: "Send test alert",
        testSent: "Test alert sent: e-mail {sent} of {to}, in-app {inApp}",
        testFailed: "Test alert: the e-mail was not sent ({reason}); the in-app alert was delivered ({inApp})",
        capUsed: "Alert e-mails this hour: {n} of {cap}",
        rules: "Rules",
        rule: "Rule",
        what: "What raises it",
        on: "On",
        thresholds: "Thresholds",
        inAppOnly: "in-app only",
        delivery: "Delivery",
        recipients: "E-mail recipients",
        recipientsHelp: "Comma-separated. Empty = every Platform Admin user: {list}",
        windowHours: "Do not re-send the same alert within (hours)",
        capPerHour: "At most this many alert e-mails per hour",
        save: "Save settings",
        saved: "Settings saved",
        open: "Open alerts",
        noneOpen: "No open alert.",
        since: "Open since",
        alert: "Alert",
        firm: "Firm",
        lastSeen: "Last seen",
        email: "E-mail",
        show: "Open the tab",
        history: "History (last 90 days)",
        noHistory: "No alert yet.",
        time: "Time",
        event: "Event",
        inApp: "In-app",
        ksa: "KSA",
        kind: { raised: "Sent", repeat: "Repeat (not re-sent)", resolved: "Resolved", capped: "Over the hourly cap (in-app + digest)",
                test: "Test alert", digest: "Daily digest", digest_none: "Digest: nothing open (none sent)" },
        mail: { sent: "sent {n}", failed: "failed {n}", capped: "over the cap", inAppOnly: "in-app only", none: "—", noRecipients: "no recipients" },
        more: "+{n} more",
        loadError: "Could not load the alerts",
        saveError: "Could not save",
      },
    },
  },
  ar: {
    s10e: {
      alerts: {
        nav: "التنبيهات",
        title: "التنبيهات التلقائية",
        intro: "تفحص المنصة نفسها كل 5 دقائق وترسل بريداً إلكترونياً إلى المستلمين أدناه (وتعرض التنبيه نفسه في جرس الإشعارات) عند حدوث خلل. لا يُعاد إرسال التنبيه نفسه خلال فترته؛ والتنبيه الذي يبقى مفتوحاً يظهر سطراً في الملخص اليومي الساعة 08:00 بتوقيت السعودية؛ وتُرسل رسالة «تمّ الحل» عند زواله.",
        lastCheck: "آخر فحص",
        never: "لم يُجرَ بعد",
        checkNow: "افحص الآن",
        checked: "تمّ الفحص",
        sendTest: "إرسال تنبيه تجريبي",
        testSent: "أُرسل التنبيه التجريبي: البريد {sent} من {to}، داخل التطبيق {inApp}",
        testFailed: "التنبيه التجريبي: لم يُرسل البريد ({reason})؛ ووصل التنبيه داخل التطبيق ({inApp})",
        capUsed: "رسائل التنبيه هذه الساعة: {n} من {cap}",
        rules: "القواعد",
        rule: "القاعدة",
        what: "ما الذي يثيرها",
        on: "مفعّلة",
        thresholds: "الحدود",
        inAppOnly: "داخل التطبيق فقط",
        delivery: "الإرسال",
        recipients: "مستلمو البريد الإلكتروني",
        recipientsHelp: "مفصولة بفواصل. فارغ = كل مستخدمي «مسؤول المنصة»: {list}",
        windowHours: "لا يُعاد إرسال التنبيه نفسه خلال (ساعات)",
        capPerHour: "أقصى عدد لرسائل التنبيه في الساعة",
        save: "حفظ الإعدادات",
        saved: "حُفظت الإعدادات",
        open: "التنبيهات المفتوحة",
        noneOpen: "لا تنبيه مفتوح.",
        since: "مفتوح منذ",
        alert: "التنبيه",
        firm: "الشركة",
        lastSeen: "آخر رصد",
        email: "البريد",
        show: "فتح التبويب",
        history: "السجل (آخر 90 يوماً)",
        noHistory: "لا تنبيه بعد.",
        time: "الوقت",
        event: "الحدث",
        inApp: "داخل التطبيق",
        ksa: "بتوقيت السعودية",
        kind: { raised: "أُرسل", repeat: "تكرار (لم يُعد إرساله)", resolved: "تمّ الحل", capped: "فوق الحد بالساعة (داخل التطبيق + الملخص)",
                test: "تنبيه تجريبي", digest: "الملخص اليومي", digest_none: "الملخص: لا شيء مفتوح (لم يُرسل)" },
        mail: { sent: "أُرسل {n}", failed: "فشل {n}", capped: "فوق الحد", inAppOnly: "داخل التطبيق فقط", none: "—", noRecipients: "لا مستلمين" },
        more: "+{n} أخرى",
        loadError: "تعذّر تحميل التنبيهات",
        saveError: "تعذّر الحفظ",
      },
    },
  },
};

export default I18N_S10E;
